module.exports = __webpack_public_path__ + "img/logo-refera.6742fb82.png";